import { TELEGRAM_CHANNEL_URL } from '../../config/contacts';

export { TELEGRAM_CHANNEL_URL };

export const SUBSCRIPTION_URL_EXAMPLE = 'https://prox1.bypass-vpn.ru:4096/sub/xxxxxxxxxxxx';

export const INCY_APP_STORE_URL = 'https://apps.apple.com/ru/app/incy/id6756943388';

export const HELP_SECTIONS = [
    {
        id: 'start',
        title: 'Начало работы',
        blocks: [
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'BypassVPN — это личный кабинет, где вы покупаете подписку и управляете ею. VPN подключается через приложение Happ или INCY на вашем телефоне или компьютере. Весь путь занимает несколько минут.',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Шаг 1. Создайте аккаунт',
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Зарегистрируйтесь или войдите на странице входа. Логин — это не email: только латинские буквы и цифры, от 3 до 32 символов, например Ladybug303. Пароль — от 6 до 32 символов, буква и цифра, без пробелов.' },
                ],
            },
            {
                type: 'subheading',
                value: 'Шаг 2. Откройте подписки',
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Подписки находятся в разделе ' },
                    { type: 'link', to: '/subscriptions', value: '«Мои подписки»' },
                    { type: 'text', value: '.' },
                ],
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Обычно подписка и URL готовы в течение 1–2 минут после оплаты. Если карточка ещё не появилась — обновите страницу «Мои подписки».' },
                ],
            },
            {
                type: 'subheading',
                value: 'Шаг 3. Подключите VPN',
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Дальше — установить Happ или INCY и добавить подписку. Подробная инструкция в разделе ' },
                    { type: 'anchor', href: '#setup', value: '«Настройка VPN»' },
                    { type: 'text', value: ' ниже на этой странице.' },
                ],
            },
        ],
    },
    {
        id: 'setup',
        title: 'Настройка VPN',
        blocks: [
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'После оплаты в карточке подписки появляется URL — ссылка, через которую Happ или INCY подтягивают серверы и настройки. Обычно он выглядит так:' },
                ],
            },
            {
                type: 'code',
                value: SUBSCRIPTION_URL_EXAMPLE,
            },
            {
                type: 'accordion',
                items: [
                    {
                        id: 'happ',
                        title: 'Happ',
                        defaultOpen: true,
                        blocks: [
                            {
                                type: 'subheading',
                                value: 'Шаг 1. Установите Happ',
                            },
                            {
                                type: 'p',
                                parts: [
                                    { type: 'text', value: 'Happ — приложение, через которое работает подписка Bypass. Скачайте его для своего устройства:' },
                                ],
                            },
                            {
                                type: 'linkGroups',
                                groups: [
                                    {
                                        label: 'iPhone, iPad, Mac',
                                        links: [
                                            {
                                                text: 'App Store (RU)',
                                                href: 'https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973',
                                            },
                                            {
                                                text: 'App Store (Global)',
                                                href: 'https://apps.apple.com/us/app/happ-proxy-utility/id6504287215',
                                            },
                                        ],
                                    },
                                    {
                                        label: 'Android',
                                        links: [
                                            {
                                                text: 'Google Play',
                                                href: 'https://play.google.com/store/apps/details?id=com.happproxy',
                                            },
                                            {
                                                text: 'APK (прямая установка)',
                                                href: 'https://github.com/Happ-proxy/happ-android/releases/latest/download/Happ.apk',
                                            },
                                        ],
                                    },
                                    {
                                        label: 'Windows',
                                        links: [
                                            {
                                                text: 'Установщик (.exe)',
                                                href: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/setup-Happ.x64.exe',
                                            },
                                        ],
                                    },
                                    {
                                        label: 'Linux',
                                        links: [
                                            {
                                                text: 'Debian / Ubuntu (.deb)',
                                                href: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/Happ.linux.x64.deb',
                                            },
                                            {
                                                text: 'Fedora / RHEL (.rpm)',
                                                href: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/Happ.linux.x64.rpm',
                                            },
                                            {
                                                text: 'Arch Linux (.pkg.tar.zst)',
                                                href: 'https://github.com/Happ-proxy/happ-desktop/releases/latest/download/Happ.linux.x64.pkg.tar.zst',
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                type: 'subheading',
                                value: 'Шаг 2. Добавьте подписку',
                            },
                            {
                                type: 'p',
                                parts: [
                                    { type: 'text', value: 'Откройте ' },
                                    { type: 'link', to: '/subscriptions', value: '«Мои подписки»' },
                                    { type: 'text', value: ', найдите активную карточку (URL уже готов, не «Готовим URL…») и действуйте по порядку:' },
                                ],
                            },
                            {
                                type: 'ol',
                                items: [
                                    'Нажмите «Открыть в Happ» — личный кабинет передаст URL в приложение',
                                    'Откроется Happ с предложением импорта. Подтвердите добавление — подписка Bypass появится в списке',
                                    {
                                        parts: [
                                            { type: 'text', value: 'Happ не открылся? Нажмите ' },
                                            { type: 'icon', name: 'copy' },
                                            { type: 'text', value: ' в карточке → в Happ нажмите ' },
                                            { type: 'icon', name: 'plus' },
                                            { type: 'text', value: ' → «Вставить из буфера обмена» и подтвердите' },
                                        ],
                                    },
                                ],
                            },
                            {
                                type: 'subheading',
                                value: 'Шаг 3. Включите VPN',
                            },
                            {
                                type: 'p',
                                parts: [
                                    { type: 'text', value: 'В Happ нажмите кнопку включения — большой переключатель или кнопку питания. Когда статус сменится на «Подключено», VPN работает. Готово.' },
                                ],
                            },
                            {
                                type: 'subheading',
                                value: 'Конфигурации в подписке',
                            },
                            {
                                type: 'p',
                                parts: [
                                    {
                                        type: 'text',
                                        value: 'В одной подписке Bypass — несколько конфигураций: VLESS и Hysteria2. Если в текущих сетевых условиях выбранная не работает или работает нестабильно, переключитесь на другую в списке серверов Happ.',
                                    },
                                ],
                            },
                            {
                                type: 'ol',
                                items: [
                                    {
                                        parts: [
                                            { type: 'text', value: 'Для работы VLESS-конфигураций откройте настройки Happ ' },
                                            { type: 'icon', name: 'settings' },
                                            { type: 'text', value: ' в левом верхнем углу и включите «Использовать Mux»' },
                                        ],
                                    },
                                    {
                                        parts: [
                                            { type: 'text', value: 'Проверить, какие конфигурации работают в вашей сети, можно кнопкой ' },
                                            { type: 'icon', name: 'speedtest' },
                                            { type: 'text', value: ' напротив названия подписки BypassVPN в Happ' },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        id: 'incy-apple-ru',
                        title: 'Happ недоступен на Apple с регионом РФ?',
                        defaultOpen: false,
                        blocks: [
                            {
                                type: 'p',
                                parts: [
                                    {
                                        type: 'text',
                                        value: 'На iPhone, iPad и Mac с Apple ID, привязанным к российскому региону, Happ может отсутствовать в App Store. В этом случае используйте приложение INCY — с тем же URL подписки Bypass.',
                                    },
                                ],
                            },
                            {
                                type: 'subheading',
                                value: 'Шаг 1. Установите INCY',
                            },
                            {
                                type: 'linkGroups',
                                groups: [
                                    {
                                        label: 'iPhone, iPad, Mac',
                                        links: [
                                            {
                                                text: 'App Store (RU)',
                                                href: INCY_APP_STORE_URL,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                type: 'subheading',
                                value: 'Шаг 2. Добавьте подписку',
                            },
                            {
                                type: 'ol',
                                items: [
                                    'В «Мои подписки» нажмите «Открыть в INCY» — URL передастся в приложение',
                                    {
                                        parts: [
                                            { type: 'text', value: 'Или нажмите ' },
                                            { type: 'icon', name: 'copy' },
                                            { type: 'text', value: ' в карточке и вставьте URL в INCY вручную' },
                                        ],
                                    },
                                    {
                                        parts: [
                                            { type: 'text', value: 'После продления обновите подписку кнопкой ' },
                                            { type: 'icon', name: 'refresh' },
                                            { type: 'text', value: ' напротив неё в INCY — так же, как в Happ' },
                                        ],
                                    },
                                ],
                            },
                            {
                                type: 'subheading',
                                value: 'Конфигурации в подписке',
                            },
                            {
                                type: 'p',
                                parts: [
                                    {
                                        type: 'text',
                                        value: 'В подписке Bypass есть конфигурации VLESS и Hysteria2. Для работы VLESS в INCY включите MUX:',
                                    },
                                ],
                            },
                            {
                                type: 'ol',
                                items: [
                                    {
                                        parts: [
                                            { type: 'text', value: 'Откройте ' },
                                            { type: 'icon', name: 'settings' },
                                            { type: 'text', value: ' Настройки → Туннель → Мультиплексирование (MUX) и включите опцию' },
                                        ],
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        id: 'subscriptions',
        title: 'Подписки',
        blocks: [
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'Все ваши подписки — в разделе «Мои подписки». Здесь видно срок действия, URL для Happ или INCY и кнопки «Открыть в Happ» и «Открыть в INCY». Одна подписка = один URL, через который приложение получает серверы и настройки.',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Статусы подписки',
            },
            {
                type: 'list',
                items: [
                    {
                        label: 'Активна',
                        text: 'всё работает: URL доступен, VPN можно включить в Happ или INCY',
                    },
                    {
                        label: 'Скоро истекает',
                        text: 'осталось несколько дней до конца срока. VPN ещё работает',
                    },
                    {
                        label: 'Неактивна',
                        text: 'срок вышел, VPN не работает',
                    },
                    {
                        label: 'Готовим URL…',
                        text: 'подписка уже создана, но ссылка ещё формируется. Подождите 1–2 минуты и обновите страницу',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Без автопродления',
            },
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'У нас нет автосписания с карты. Подписка не продлевается сама — когда срок подходит к концу, вы сами решаете, продлевать её или нет. Если не продлить, VPN перестанет работать после окончания оплаченного периода, без дополнительных списаний.',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Удаление',
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Удалить можно только истёкшую подписку — это необратимо.' },
                ],
            },
        ],
    },
    {
        id: 'pricing',
        title: 'Тарифы',
        blocks: [
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'Один понятный продукт: вы выбираете только количество устройств для одновременного подключения к VPN. Период подписки — 31 день.',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Что такое «устройство»',
            },
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'Одно устройство — один гаджет с активным VPN: телефон, ноутбук, планшет. Нужен VPN только на телефоне — хватит минимума. Хотите раздать на семью — берите больше. Выбрать можно от 2 до 50.',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Как считается цена',
            },
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'Чем больше устройств в подписке — тем выше итоговая сумма за период. Зато на каждое устройство получается выгоднее: как при покупке «оптом», а не по одной штуке.',
                    },
                ],
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Актуальные подписки — в разделе ' },
                    { type: 'link', to: '/subscriptions', value: '«Мои подписки»' },
                    { type: 'text', value: '.' },
                ],
            },
        ],
    },
    {
        id: 'referral',
        title: 'Рефералы',
        blocks: [
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'Реферальная программа — способ получать баллы за приглашения. Баллы копятся в аккаунте: 1 балл = 1 ₽.',
                    },
                ],
            },
            {
                type: 'subheading',
                value: 'Ваш код',
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'У каждого пользователя есть свой реферальный код — его видно в разделе ' },
                    { type: 'link', to: '/account', value: '«Аккаунт»' },
                    { type: 'text', value: '. Отправьте код другу в мессенджере или соцсети. За каждую купленную им подписку вам начислят 15% от суммы его оплаты баллами.' },
                ],
            },
            {
                type: 'subheading',
                value: 'Код друга',
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Если вас пригласили — привяжите код друга один раз в «Аккаунте». После этого с каждой вашей покупки вернётся кэшбэк 10% баллами. Свой код привязать нельзя, сменить код после привязки тоже нельзя.' },
                ],
            },
        ],
    },
    {
        id: 'account',
        title: 'Аккаунт',
        blocks: [
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'В разделе «Аккаунт» — ваш профиль, баланс баллов, реферальная программа и настройки. Сюда же можно перейти из меню.',
                    },
                ],
            },
            {
                type: 'list',
                items: [
                    {
                        label: 'Профиль',
                        text: 'логин и сколько баллов на счету',
                    },
                    {
                        label: 'Реферальная программа',
                        text: 'ваш код для приглашений, привязка кода друга и статистика',
                    },
                    {
                        label: 'Сменить пароль',
                        text: 'обновить пароль от личного кабинета',
                    },
                    {
                        label: 'Тема',
                        text: 'светлая, тёмная или как в системе — на ваш выбор',
                    },
                ],
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Логин — не email. Только латинские буквы и цифры, например Ladybug303. Если забыли пароль — откройте ' },
                    { type: 'anchor', href: '#support', value: 'чат поддержки' },
                    { type: 'text', value: '.' },
                ],
            },
        ],
    },
    {
        id: 'support',
        title: 'Поддержка',
        blocks: [
            {
                type: 'p',
                parts: [
                    {
                        type: 'text',
                        value: 'Если что-то не получается — оплата, подписка не появилась, VPN не подключается — откройте чат поддержки в углу экрана на любой странице сайта.',
                    },
                ],
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Новости сервиса — в ' },
                    { type: 'external', href: TELEGRAM_CHANNEL_URL, value: 'нашем Telegram-канале' },
                    { type: 'text', value: '.' },
                ],
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Реквизиты и контакты — на странице ' },
                    { type: 'link', to: '/info', value: '«Контакты»' },
                    { type: 'text', value: '.' },
                ],
            },
            {
                type: 'p',
                parts: [
                    { type: 'text', value: 'Документы: ' },
                    { type: 'link', to: '/privacy', value: 'политика конфиденциальности' },
                    { type: 'text', value: ', ' },
                    { type: 'link', to: '/terms', value: 'правила использования' },
                    { type: 'text', value: '.' },
                ],
            },
        ],
    },
];
